import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingBranchPc from './designcomponents/sunbaebriefingbranchpc';
import SunbaeBriefingBranchMobile from './designcomponents/sunbaebriefingbranchmobile';
import { HANAM_CONFIG } from '../lib/briefingBranchConfig';

export default function SunbaeBriefingHanam() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile
    ? <SunbaeBriefingBranchMobile config={HANAM_CONFIG} />
    : <SunbaeBriefingBranchPc config={HANAM_CONFIG} />;
}
